/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

const invalidKeysInputNumber = ["e", ".", "-", "+"];

const getRows = (data, onChange, pausado) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        nombre: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
              {item?.Descripcion ? item?.Descripcion : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        talle: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
              {item?.TALLE ? item?.TALLE : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        colour: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
              {item?.COLOR ? item?.COLOR : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        codProv: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
              {item?.CodProv ? item?.CodProv : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftInput
              defaultValue={
                // pausado && item.Cantidad > 0
                //   ? parseInt(item?.Cantidad)
                //   : parseInt(item?.Cantidad) > 0
                //   ? parseInt(item?.Cantidad)
                //   : ""
                parseInt(item?.Cantidad)
              }
              type="number"
              onChange={(e) => onChange(e, item?.IdRemito, item)}
              onKeyDown={(e) => {
                if (invalidKeysInputNumber.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => {
                e.preventDefault();
              }}
              sx={{
                "& input[type=number]": {
                  "-moz-appearance": "textfield",
                },
                "& input[type=number]::-webkit-outer-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 0,
                },
                "& input[type=number]::-webkit-inner-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 0,
                },
              }}
            />
          </SoftBox>
        ),
        backgroundColor: item.Agregado ? "#FFEB99" : null,
      });
    });
  }

  return rows;
};

const columns = [
  { name: "codProv", desc: "Cod. Prov.", align: "center" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "talle", desc: "Talle", align: "center" },
  { name: "colour", desc: "Color", align: "center" },
  { name: "cantidad", desc: "Cantidad recibida", align: "center" },
];

export default { columns, getRows };
